import React from 'react';
import { connect } from 'react-redux';
import { getTenantState } from '../../../store/selectors';
import { getUserCounts, getUserCountsCsv } from '../../../store/actions';
import SidebarTitle from '../basic-style-components/SidebarTitle';
import Loading from '../../utility/Loading';
import TitleAndData from '../basic-style-components/TitleAndData';
import { reportingCopy } from '../../../copy/advisor-dashboard/advisor-dashboard-base.json';

export class Reporting extends React.Component {
  _isMounted = false;

  constructor(props) {
    super(props);
    this.state = {
      counts: {
        total: 0,
        thisYear: 0,
      },
      loading: true,
    };
  }

  componentDidMount = async () => {
    await this.prepComponentData();
  };

  prepComponentData = async () => {
    const counts = await this.props.getUserCounts();
    this.setState({
      counts,
      loading: false,
    });
  };

  getCsv = async () => {
    const csv = await this.props.getUserCountsCsv();
    return csv;
  };

  render() {
    const { loading, counts } = this.state;
    return (
      <SidebarTitle
        tenant={this.props.tenant}
        title={reportingCopy.heading1}
        csvCallback={this.getCsv}
        csvTitle="new-and-all-time-users"
      >
        {loading ? (
          <Loading height="100%" />
        ) : (
          <>
            <div className="reporting__padding-right reporting__half-width reporting__users-counts">
              <TitleAndData
                title={reportingCopy.subheading1}
                data={counts.thisYear}
                tenant={this.props.tenant}
              />
            </div>
            <div className="reporting__half-width reporting__users-counts">
              <TitleAndData
                title={reportingCopy.subheading2}
                data={counts.total}
                tenant={this.props.tenant}
              />
            </div>
          </>
        )}
      </SidebarTitle>
    );
  }
}

function mapStateToProps(state) {
  const tenant = getTenantState(state);
  return { tenant };
}

export default connect(mapStateToProps, {
  getUserCounts,
  getUserCountsCsv,
})(Reporting);
